import { getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const videoTutorial = data =>
  getInstance().get(API.VIDEO_TUTORIAL, {
    params: data,
  })
